import api from '@pray/shared/utils/api';

/** Undoes a soft delete on up to 100 episodes owned by the artist. The server answers 204. */
export async function restoreContent(artistId: string, contentIds: string[]) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentIds?.length) throw Error('At least one content ID is required');

  const url = `/web/studio/artists/${artistId}/content/restore`;

  /* eslint-disable camelcase */
  await api.executePostRequest(url, { content_ids: contentIds });
  /* eslint-enable camelcase */

  return { success: true };
}
